var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    {
      staticClass: "preview-form_item",
      class: [_vm.formType, "form-label_" + _vm.textAlign],
      style: { "padding-left": _vm.paddingLeft },
      attrs: { prop: _vm.variableName, rules: _vm.rules }
    },
    [
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.labelPosition == "left",
              expression: "labelPosition=='left'"
            }
          ],
          staticClass: "form-item_label_left",
          style: {
            minWidth: _vm.labelWidth,
            textAlign: _vm.textAlign
          },
          attrs: { slot: "label" },
          slot: "label"
        },
        [_vm._v(_vm._s(_vm.labelText))]
      ),
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      _vm.labelPosition == "right"
        ? _c(
            "span",
            {
              staticClass: "form-item_label_right",
              style: {
                minWidth: _vm.labelWidth,
                textAlign: _vm.textAlign
              }
            },
            [_vm._v(_vm._s(_vm.labelText))]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-594e1a98", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-594e1a98","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base_package/PreviewFormItem.vue
// module id = null
// module chunks = 